import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-eld-edit",
  "use": "icon-eld-edit-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-eld-edit\"><circle cx=\"16\" cy=\"16\" r=\"16\" fill=\"#fff\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.667 12c0-.736.597-1.333 1.333-1.333h2.667a.667.667 0 0 1 0 1.333H12v8h8v-3a.667.667 0 0 1 1.333 0v3c0 .736-.597 1.333-1.333 1.333h-8A1.333 1.333 0 0 1 10.667 20v-8Zm10.138-.805c.26.26.26.683 0 .943l-5.472 5.529h-1v-1l5.529-5.472c.26-.26.682-.26.943 0Z\" fill=\"#4066D4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol